<template>
  <main class="min-h-[calc(100vh-var(--page-header-height))]">
    <slot />
  </main>
</template>
